/**
 * Pequemimo welcome popup (10% off). Shows once after a short delay unless
 * the visitor dismissed/subscribed. Opens immediately if a success message
 * is present (right after submitting). Remembers via localStorage.
 */
(function () {
  var KEY = 'pm_nlpop_seen';
  var DELAY = 7000;
  var REMEMBER_DAYS = 14;

  var pop = document.getElementById('nlpop');
  if (!pop) return;

  function open() {
    pop.hidden = false;
    pop.classList.add('is-open');
    pop.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
  }
  function close() {
    pop.classList.remove('is-open');
    pop.setAttribute('aria-hidden', 'true');
    pop.hidden = true;
    document.body.classList.remove('cart-open');
    try {
      localStorage.setItem(KEY, String(Date.now()));
    } catch (e) {}
  }

  function recentlySeen() {
    try {
      var t = parseInt(localStorage.getItem(KEY) || '0', 10);
      return t && Date.now() - t < REMEMBER_DAYS * 86400000;
    } catch (e) {
      return false;
    }
  }

  // If a success message is showing (just subscribed), open right away.
  if (pop.querySelector('.nlpop__success')) {
    open();
  } else if (!recentlySeen()) {
    setTimeout(open, DELAY);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-nlpop-close]')) {
      e.preventDefault();
      close();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && pop.classList.contains('is-open')) close();
  });
})();
